import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
    root: {},
    tabPanel: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingInlineStart: 0,
      paddingInlineEnd: 0,
    },
    containButton: {
      '& > *': {
        margin: `5px 10px`,
      },
    },
    buttonProgress: {
      color: theme.palette.primary.main,
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -8,
      marginLeft: -12,
    },
    headerContainer: {
      justifyContent: 'flex-end',
      [theme.breakpoints.down('sm')]: {
        alignItems: 'flex-start',
        flexDirection: 'column',
      },
    },
    submitContainer: {
      paddingTop: theme.spacing(2),
      borderTop: `1px solid ${theme.palette.grey[300]}`,
    },
  }));